<div class="payment-loading">
	<div class="payment-loading-inner content-placeholder">
		<svg height="0" width="0">
			<defs>
				<clipPath id="svg-placeholder">
					<rect height="20" rx="4" ry="2" width="125" x="0" y="0"></rect>
					<rect height="15" rx="4" ry="2" width="45" x="0" y="25"></rect>
					<rect height="22" rx="4" ry="4" width="135" x="0" y="64"></rect>
					<rect height="22" rx="4" ry="4" width="90" x="230" y="64"></rect>
					<rect height="40" rx="4" ry="4" width="300" x="0" y="102"></rect>
					<rect height="37" rx="4" ry="4" width="300" x="0" y="158"></rect>
					<rect height="2" rx="4" ry="4" width="300" x="0" y="214"></rect>
					<rect height="20" rx="4" ry="2" width="45" x="0" y="235"></rect>
					<rect height="20" rx="4" ry="2" width="90" x="230" y="235"></rect>
					<rect height="20" rx="4" ry="2" width="70" x="0" y="268"></rect>
					<rect height="20" rx="4" ry="2" width="70" x="230" y="268"></rect>
					<rect height="2" rx="4" ry="4" width="300" x="0" y="301"></rect>
					<rect height="25" rx="4" ry="2" width="50" x="0" y="320"></rect>
					<rect height="25" rx="4" ry="2" width="90" x="215" y="320"></rect>
				</clipPath>
			</defs>
		</svg>
	</div>
</div>
